import ReservationFilters from './reservation-filters'

let sharedMutations = []

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    ReservationFilters.state
  ),
  mutations: Object.assign(
    ReservationFilters.mutations
  ),
  sharedMutations: sharedMutations
}



// WEBPACK FOOTER //
// ./src/store/reservation/index.js